import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CollectionDto } from '../model/collection.model';
import { environment } from '../../environments/environment';
import { HttpClientHelper } from './http-client-helper.service';
import { firstValueFrom, map, tap } from 'rxjs';
import { ConsoleLoggerService } from './console-logger.service';
import { GridRequest } from '../model/grid-request.model';
import {ProjectTypeListItem} from '../model/project-type.model';


@Injectable({
  providedIn: 'root'
})
export class ProjectTypeService {

  constructor(private http: HttpClient,
              private httpClientHelper: HttpClientHelper,
              private log: ConsoleLoggerService) {
  }

  getProjectTypes() {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/projecttypes`;
    const observable = this.http.get<CollectionDto<ProjectTypeListItem>>(url, { params: params })
      .pipe(tap(r => this.log.debug('project types: ', r)))
      .pipe(map(c => c.items))

    return firstValueFrom(observable)
  }

  getPagedProjectTypes(request: GridRequest) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/projecttypes/paged`;
    const observable = this.http.post<CollectionDto<ProjectTypeListItem>>(url, request, { params: params })
      .pipe(tap(r => this.log.debug('project types: ', r)));

    return firstValueFrom(observable);
  }

  saveProjectType(projectType: ProjectTypeListItem) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/projecttypes`;
    const observable = this.http.post<ProjectTypeListItem>(url, projectType, { params: params })
      .pipe(tap(r => this.log.debug('project type save response: ', r)));

    return firstValueFrom(observable);
  }

  deleteProjectType(id: number) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/projecttypes/${id}`;
    const observable = this.http.delete<boolean>(url, { params: params })
      .pipe(tap(r => this.log.debug('project type deleted: ', r)))

    return firstValueFrom(observable)
  }

  updateProjectTypeStatus(id: number, active: boolean) {
    let params = this.httpClientHelper.createHttpParams();
    params = params.append('active', active);

    let url = environment.apiUrl + `/projecttypes/${id}/status`;
    const observable = this.http.put<boolean>(url, null, { params: params })
      .pipe(tap(r => this.log.debug('Project Types updated: ', r)))

    return firstValueFrom(observable)
  }
}
